<script setup lang="ts">
const appVersion = useRuntimeConfig().public.appVersion
const route = useRoute()

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/player/', label: 'Player' },
  { to: '/pgm-maker/', label: 'PGM Maker' },
  { to: '/converter/', label: 'Converter' },
  { to: '/docs/', label: 'Docs' },
]
const SOON_LINKS: string[] = []
</script>

<template>
  <div class="grid min-h-dvh grid-cols-[26px_1fr_26px] max-[720px]:grid-cols-1">
    <div class="wood-cheek left max-[720px]:hidden"></div>

    <UpdateBanner />

    <div class="mx-auto flex w-full max-w-[1360px] flex-col px-6 pb-6 pt-5 max-[720px]:px-4 max-[720px]:pb-3">
      <div class="mb-4.5 flex flex-wrap items-center justify-between gap-4 border-b border-border pb-3.5">
        <NuxtLink to="/" aria-label="MPC1000.com home" class="group flex items-center gap-2.5 text-ink">
          <span
            aria-hidden="true"
            class="grid h-8 w-8 shrink-0 grid-rows-[9px_1fr] gap-1 rounded border border-border bg-panel-2 p-1 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.55)]"
          >
            <span class="rounded-[2px] border border-phosphor/45 bg-phosphor/15 shadow-[0_0_8px_rgba(143,245,213,0.24)]"></span>
            <span class="grid grid-cols-3 gap-0.5">
              <span class="rounded-[1px] bg-muted-dim/45"></span>
              <span class="rounded-[1px] bg-muted-dim/45"></span>
              <span class="rounded-[1px] bg-accent/80"></span>
              <span class="rounded-[1px] bg-muted-dim/45"></span>
              <span class="rounded-[1px] bg-muted-dim/45"></span>
              <span class="rounded-[1px] bg-muted-dim/45"></span>
            </span>
          </span>
          <span class="flex items-baseline gap-1">
            <span class="font-display text-[28px] font-bold uppercase leading-none group-hover:text-phosphor">MPC1000</span>
            <small class="font-mono text-xs font-normal uppercase text-muted-dim">.com</small>
          </span>
        </NuxtLink>
        <nav class="flex items-center gap-4 text-xs uppercase tracking-wide">
          <NuxtLink
            v-for="link in NAV_LINKS"
            :key="link.to"
            :to="link.to"
            class="hover:text-ink"
            :class="route.path === link.to ? 'font-semibold text-ink' : 'text-muted'"
          >
            {{ link.label }}
          </NuxtLink>
          <span v-for="label in SOON_LINKS" :key="label" class="text-muted-dim" :title="`${label} - coming soon`">
            {{ label }}
          </span>
        </nav>
      </div>

      <slot />

      <footer class="mt-6 flex flex-col items-center gap-1 text-center text-xs text-muted-dim max-[720px]:mt-4">
        <div class="font-mono">MPC1000.com v{{ appVersion }}</div>
        <div class="max-w-[560px] leading-snug">
          Unofficial, fan-made hub for the MPC1000/MPC2500 &amp; JJOS community - not affiliated
          with or endorsed by Akai Professional or JJOS. Everything currently runs locally in
          your browser; no project file is uploaded anywhere. Provided as-is, with no warranty.
        </div>
      </footer>
    </div>

    <div class="wood-cheek right max-[720px]:hidden"></div>
  </div>
</template>
